import React, { SVGProps } from 'react'
export const FirstDefaultRightSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M14.37 15.324C12.968 11.261 9.155 7.396 0 4.969V4c9.328 2.473 13.74 6.526 15.287 11.008 1.532 4.441.312 9.164-1.007 12.869-.779 2.188-2.683 3.742-5.174 4.855C6.61 33.846 3.397 34.555 0 35v-.968c3.358-.44 6.34-1.126 8.71-2.184 2.374-1.06 4.004-2.462 4.656-4.296 1.31-3.68 2.42-8.124 1.004-12.228Z"
      clipRule="evenodd"
    />
  </svg>
)
